import ky from "ky-universal";
import Cookies from "js-cookie";
import { parse, addHours } from "date-fns";
import { captureException } from "@sentry/react";

import extendOrInitSession from "./extendOrInitSession";

import baseFields from "../../../config/api/baseFields";
import { IS_PROD } from "../../../constants/env";
import {
  COOKIE_LOG_TRACKING_CLIENT_ID,
  COOKIE_LOG_TRACKING_SESSION_ID,
} from "../../../constants/cookie";

import authUtils from "../auth";
import formatToTaiwanTime from "../formatToTaiwanTime";
import getAge from "../getAge";

const API_ENDPOINT = IS_PROD
  ? "https://in-stream.linetv.tw/v1/legacy"
  : "https://in-stream-dev.linetv.tw/v1/legacy";

const { appId, version } = baseFields;

/**
 * user_profile, user_behavior, user_preference 事件追蹤
 * @see {@link https://docs.google.com/spreadsheets/d/1A2nZX4XhYauCy96MC60791RjGdBVa-aiTHbnxcPlMa8/edit#gid=66300510}
 *
 * @param {object} payload
 */
async function sendLegacyEvent(payload) {
  await extendOrInitSession();

  const { profile } = payload;
  const social = profile?.social?.[0];

  const data = {
    // general fields
    app_id: appId,
    instance_id: Cookies.get(COOKIE_LOG_TRACKING_CLIENT_ID) || "",
    session_id: Cookies.get(COOKIE_LOG_TRACKING_SESSION_ID) || "",
    timestamp: formatToTaiwanTime(new Date(), "yyyy/MM/dd HH:mm:ss"),
    device: payload.isMobile ? "mobile_web" : "desktop_web",
    version,

    ad_id: (await authUtils.getClientId()) || "",
    chocomember_id: profile?.accountId || "",
    device_id: "",
    age:
      getAge(addHours(parse(profile?.birthday, "yyyy/MM/dd", new Date()), 8)) ||
      "",
    birthday: profile?.birthday || "",
    gender: profile?.gender || "",
    social_id: social?.id || "",
    social_email: profile?.email || "",
    social_type: social?.provider || "",
    social_name: profile?.name || "",
    subscribe: profile?.isVip ? "yes" : "no",

    language: navigator.language || navigator.userLanguage || "",
    carrier: "",
    country: "",
    city: "",
    dist: "",
    client_ip: "",
    connection: "",
    latitude: "",
    longitude: "",
    os: "",

    // event fields
    api: payload.api || "",
    backup1: payload.backup1 || "",
    backup2: payload.backup2 || "",
    event1: payload.event1 || "",
    event2: payload.event2 || "",
    event3: payload.event3 || "",
    event4: payload.event4 || "",
    event5: payload.event5 || "",
    event6: payload.event6 || "",
    event7: payload.event7 || "",
    event8: payload.event8 || "",
    event9: payload.event9 || "",
    event10: payload.event10 || "",
  };

  ky.post(API_ENDPOINT, { json: data }).catch((error) => {
    captureException(error, {
      extra: profile,
    });
  });
}

export default sendLegacyEvent;
